module.exports = __webpack_public_path__ + "img/sattellite.ec55089d.png";